import React, { useState, useEffect, useContext } from "react";
import { connect } from "react-redux";
import { useIntl } from "react-intl";

import Chart from "react-apexcharts";
import moment from "moment";

import Card from "../../UI/Card/Card";
import * as Utils from "../../Utils/BillingUtils";
import * as ChartUtils from "../../Utils/ChartsUtils";

import EmptyState from "../../UI/State/EmptyState";
import { faChartBar } from "@fortawesome/free-solid-svg-icons";
import { ThemeContext } from "../../Context/ThemeWrapper";

import * as InvoicesActions from "../../../middleware/Store/Actions/InvoicesActions";

import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "INVOICES_STATISTICS";

const InvoicesStatistics = (props) => {

    const intl = useIntl();
    const themeContext = useContext(ThemeContext);
    const title = intl.messages.invoicesStatTitle;
    const subtitle = intl.messages.invoicesStatSubTitle;
    
    const [data, setData] = useState([]);
    const [currency, setCurrency] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect");     
            if (props.account && props.account.data && props.account.data.billingAndPayment) {
                setCurrency(props.account.data.billingAndPayment.currency);
            }
    }, [props.account]);

    // let content=[
    //   {"invoiceDate":"2021-12-01","amount":22},
    //   {"invoiceDate":"2021-11-01","amount":20},
    //   {"invoiceDate":"2021-10-01","amount":30},
    //   {"invoiceDate":"2021-09-01","amount":32},
    //   {"invoiceDate":"2021-08-01","amount":25},
    //   {"invoiceDate":"2021-07-01","amount":27},
    //   {"invoiceDate":"2021-06-01","amount":19},
    //   {"invoiceDate":"2021-05-01","amount":33},
    //   {"invoiceDate":"2021-04-01","amount":33},
    //   {"invoiceDate":"2021-03-01","amount":25},
    //   {"invoiceDate":"2021-02-01","amount":20},
    //   {"invoiceDate":"2021-01-01","amount":25},
    //   {"invoiceDate":"2020-12-01","amount":27},
    //   {"invoiceDate":"2020-11-01","amount":23},
    //   {"invoiceDate":"2020-10-01","amount":17},
    //   {"invoiceDate":"2020-9-01","amount":20},
    // ]

    useEffect(() => {
      LogService.trace(LOG_TAG, "setData");
      
      if (props.invoices && props.invoices.length > 0) {
        setData(prepareStatistics(props.invoices));
        //setData(prepareStatistics(content));
        //console.log("data="+ JSON.stringify(data));
      }
    }, [props.invoices]);

    useEffect(() => {
      setLoading(true);
        if (props.user){
            props.getListOfInvoices(props.user.id)
            .then(() => {
              setLoading(false)
          })
        }
    }, []);

    const prepareStatistics = (data)  => {
      const result = [];
      let line = {name: "", data: Array(12).fill(null)};
      
      line.name = new Date(data[0].invoiceDate).getFullYear()
                         
      data.forEach((item) => {
        let year = new Date(item.invoiceDate).getFullYear();
        let month = new Date(item.invoiceDate).getMonth();

        if(line.name !== year){
          result.push(line);
          line = {name: "", data: Array(12).fill(null)};
          line.name = year;
        }

        line.data[month] = item.amount;        
      });

      result.push(line);
      return result;
  }
 

    const chartOptions = {
      series: data,
      options: {
        chart: {
          background: "transparent",
          height: "100%",
          defaultLocale: ChartUtils.getDefaultLocale(intl),
          locales: ChartUtils.getAvailableLanguageCodes()
        },
        dataLabels: {
          enabled: false,
        },
        theme: {
          mode: themeContext.theme, 
          palette: 'palette2', 
          monochrome: {
              enabled: false,
              color: '#255aee',
              shadeTo: 'light',
              shadeIntensity: 0.65
          },
        },
      
        stroke: {
          curve: "smooth"
        },
        xaxis: {
          categories: [
            Utils.capitalizeFirstLetter(intl.formatDate("01", { month: "short" })),
            Utils.capitalizeFirstLetter(intl.formatDate("02", { month: "short" })),
            Utils.capitalizeFirstLetter(intl.formatDate("03", { month: "short" })),
            Utils.capitalizeFirstLetter(intl.formatDate("04", { month: "short" })),
            Utils.capitalizeFirstLetter(intl.formatDate("05", { month: "short" })),
            Utils.capitalizeFirstLetter(intl.formatDate("06", { month: "short" })),
            Utils.capitalizeFirstLetter(intl.formatDate("07", { month: "short" })),
            Utils.capitalizeFirstLetter(intl.formatDate("08", { month: "short" })),
            Utils.capitalizeFirstLetter(intl.formatDate("09", { month: "short" })),
            Utils.capitalizeFirstLetter(intl.formatDate("10", { month: "short" })),
            Utils.capitalizeFirstLetter(intl.formatDate("11", { month: "short" })),
            Utils.capitalizeFirstLetter(intl.formatDate("12", { month: "short" })),
          ]
        },
        yaxis: [
          {
            seriesName: "Power",
            min: 0,
            max: 100,
            title: {
              text: intl.formatMessage({id: "invoicesStatCurrency"},{value: currency})
            }
          }
        ],
        legend: {
          position: "bottom"
        },
        grid: {
          show: true
        },
        annotations: {
          xaxis: [{
            x: Utils.capitalizeFirstLetter(intl.formatDate(Date.now(), { month: "short" })),
            strokeDashArray: 0,
            borderColor: '#775DD0',
            label: {
              borderColor: '#775DD0',
              style: {
                color: '#fff',
                background: '#775DD0',
              },
              text: 'Now',
            }
          }]
        }
      }
    }; 


    return (
        <Card title={title} subtitle={subtitle} >
            <div className="row h-100">
                <div className="col">
                    <div id="billingInvoices-list" className="h-100">
                        {props.hasInvoices && !loading && (
                            <Chart
                            options={chartOptions.options}
                            series={chartOptions.series}
                            type="line"
                            height="100%"
                            //className="grafik"
                            //defaultLocal={intl.locale}
                            />
                        )}
                        {(!props.hasInvoices || loading )&& (
                            <div id="billingInvoices-list-empty-content" >
                                <EmptyState icon={faChartBar} text={intl.messages.noStatistics} progress={loading}/>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Card>
    )
}

const mapStateToProps = state => {
    let getOfficialInvoices = invoices => {

        let val = invoices.filter(invoice => {
            return invoice.status === "Posted";
        });
        
        function compare(a, b) {
            if (moment(a.invoiceDate).isBefore(moment(b.invoiceDate))) return 1;
            if (moment(a.invoiceDate).isAfter(moment(b.invoiceDate))) return -1;
            return 0;
          }

        return val.sort(compare);
    };

    return {
        user: state.contacts.user,
        account: state.invoices.account,
        hasInvoices: Utils.hasInvoicesReceipt(state.invoices),
        invoices: getOfficialInvoices(state.invoices.invoices),
        progress: state.invoices.downloadInvoiceFileProgress,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getListOfInvoices: (userId) => dispatch(InvoicesActions.getListOfInvoices(userId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoicesStatistics);